import React from "react";

function SmartQuestionaireStepWizard(props) {
  return (
    <div className="step_wizard step">
      <div className="container">
        <ul className="steps_list mb-0 ps-0">
          <li className={`${props.step > 1 ? `active` : ``}`}>Smart Form Details</li>
          <li className="dashed_border" />
          <li className={`${props.step >= 2 && props.isDone === true ? `active` : ``}`}>Form Builder</li>
        </ul>
      </div>
    </div>
  );
}

export default SmartQuestionaireStepWizard; 